import _ from 'lodash';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { startSubmit } from 'redux-form';
import { getPostBySlug } from '../../selectors/post-selectors';
import { getCategory } from '../../selectors/categories-selectors';
import { fetchPost } from '../../actions/fetch-post';
import { fetchPostAndRedirect } from '../../actions/fetch-post-and-redirect';
import { updatePost } from '../../actions/update-post';
import goBack from '../../actions/go-back';
import AppLoaded from '../../components/app-loaded';
import messages, { POST_UPDATE } from '../../components/message/messages';
import PostPageLayout from '../../components/post-page-layout';
import PostForm from '../../components/post-form';
import { pageOpened } from '../../actions/page-opened';
import { openModal } from '../../actions/open-modal';
import { POST_EDIT_PAGE } from '../../services/detect-route';
import { MODAL_TYPE_DISCARD_POST } from '../../constants/modal-types';
import { getFocusableContainerId } from '../../components/text-editor/modifiers/text-editor-utils';
import withEnvironment from '../../hoc/with-environment';

export class PostEditPage extends Component {
  static fetchData = ({ store, params, search }) => {
    return store.dispatch(
      fetchPostAndRedirect(
        params.categorySlug,
        params.postSlug,
        search,
        (category, post, search) => `/${category.slug}/${post.slug}/edit${search}`
      )
    );
  };

  componentDidMount() {
    this.props.pageOpened({ page: POST_EDIT_PAGE });
  }

  componentWillMount() {
    this.props.fetchPost();
  }

  handleSubmit = post => {
    const { updatePost, showMessage } = this.props;
    updatePost({ ...this.props.post, ...post }).then(() =>
      showMessage(messages[POST_UPDATE].content(), messages[POST_UPDATE].type)
    );
  };

  handleCancel = isModified => {
    const { slug: categorySlug } = this.props.category;
    if (isModified) {
      return this.props.openModal(MODAL_TYPE_DISCARD_POST, { categorySlug }, getFocusableContainerId('post'));
    } else {
      return this.props.goBack(`/${categorySlug}`);
    }
  };

  render() {
    const { post, submit: handleSubmitButtonClick } = this.props;
    if (!post) {
      return null;
    }

    return (
      <PostPageLayout>
        <PostForm
          initialValues={post}
          onSubmit={this.handleSubmit}
          onSubmitButtonClick={handleSubmitButtonClick}
          onCancel={this.handleCancel}
          postId={post._id}
        />
        <AppLoaded/>
      </PostPageLayout>
    );
  }
}

PostEditPage.propTypes = {
  fetchPost: PropTypes.func.isRequired,
  updatePost: PropTypes.func.isRequired,
  showMessage: PropTypes.func.isRequired,
  submit: PropTypes.func.isRequired,
  goBack: PropTypes.func.isRequired,
  openModal: PropTypes.func.isRequired,
  pageOpened: PropTypes.func.isRequired,
  post: PropTypes.object,
  category: PropTypes.object,
};

const mapStateToProps = (state, ownProps) => {
  const post = getPostBySlug(state, ownProps.params.postSlug);
  return {
    post,
    postForm: state.postForm,
    category: getCategory(state, post && post.categoryId),
  };
};

const mapDispatchToProps = (dispatch, { params: { postSlug } }) =>
  bindActionCreators(
    {
      fetchPost: () => fetchPost(postSlug),
      updatePost,
      goBack,
      openModal,
      pageOpened,
      submit: () => startSubmit('post'),
    },
    dispatch
  );

export default _.flowRight(
  connect(mapStateToProps, mapDispatchToProps),
  withEnvironment({ showMessage: 'showMessage' })
)(PostEditPage);



// WEBPACK FOOTER //
// ./app/containers/post-edit-page/post-edit-page.js